import { Button } from "@package/subframe/components/Button";
import { IconWithLogoBackground } from "@package/subframe/components/IconWithLogoBackground";
import { FeatherInfo, FeatherPause } from "@subframe/core";

import { Dialog, DialogContent } from "@/components/ui/dialog";

interface PauseTemplateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  templateName: string;
  isPausing: boolean;
  onPause: () => void;
}

export function PauseTemplateDialog({
  open,
  onOpenChange,
  templateName,
  isPausing,
  onPause,
}: PauseTemplateDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0 sm:max-w-[448px]">
        <div className="flex h-full w-full flex-col items-start gap-6 px-8 py-8">
          <div className="flex w-full items-center gap-4">
            <IconWithLogoBackground
              variant="neutral"
              size="large"
              icon={<FeatherPause />}
            />
            <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1">
              <span className="text-heading-3 font-heading-3 text-default-font">
                Pause template
              </span>
              <span className="text-body font-body text-subtext-color">
                This will unpublish this template for your staff.
              </span>
            </div>
          </div>

          <div className="flex w-full flex-col items-start gap-4">
            <span className="text-body font-body text-default-font">
              Are you sure you want to pause the &quot;{templateName}&quot;
              template? This will:
            </span>
            <div className="flex w-full flex-col items-start gap-2">
              <div className="flex w-full items-start gap-2">
                <span className="text-body font-body text-default-font">•</span>
                <span className="text-body font-body text-default-font">
                  Cancel all future scheduled instances
                </span>
              </div>
              <div className="flex w-full items-start gap-2">
                <span className="text-body font-body text-default-font">•</span>
                <span className="text-body font-body text-default-font">
                  Remove it from users active checklists
                </span>
              </div>
              <div className="flex w-full items-start gap-2">
                <span className="text-body font-body text-default-font">•</span>
                <span className="text-body font-body text-default-font">
                  Keep all historical completion data
                </span>
              </div>
            </div>
            <div className="flex w-full items-start gap-2 rounded-sm bg-neutral-50 px-3 py-3">
              <FeatherInfo className="text-body font-body text-subtext-color" />
              <span className="grow shrink-0 basis-0 text-caption font-caption text-subtext-color">
                You can reactivate this template later by setting a new
                schedule.
              </span>
            </div>
          </div>

          <div className="flex w-full items-center justify-end gap-2">
            <Button
              variant="neutral-secondary"
              size="large"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
            <Button
              variant="neutral-primary"
              size="large"
              onClick={onPause}
              disabled={isPausing}
            >
              {isPausing ? "Pausing..." : "Pause template"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
